import gsap from "gsap";
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";

gsap.registerPlugin(Draggable, InertiaPlugin);

class ImageCompare extends HTMLElement {
  constructor() {
    super();

    this.wrapper = this.querySelector(".wrapper");
    this.clipped = this.querySelector(".clipped");
    this.setup = this.setup.bind(this);

    this.setup();

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", () => {
        this.setup();
      });
    }
  }

  setup() {
    let ratio = 0.5;
    const clipped = this.clipped;
    const wrapper = this.wrapper;
    const dragEl = this.querySelector('.dragger');
    const dragger = new Draggable(dragEl, {
      type: "x",
      inertia: false,
      bounds: wrapper,
      resistance: 300,
      zIndexBoost: false,
      onDrag: function () {
        const width = wrapper.getBoundingClientRect().width;
        gsap.set(clipped, {
          clipPath: `inset(0px ${width - this.x}px 0px 0px)`,
        });
        ratio = this.x / width;
      },
    });

    const resizeObserver = new ResizeObserver((entries) => {
      const width = wrapper.getBoundingClientRect().width;
      const x = ratio * width;
      gsap.set(dragEl, {
        x: x,
      });
      gsap.set(clipped, {
        clipPath: `inset(0px ${width - x}px 0px 0px)`,
      });
      dragger.update(true);
    });

    resizeObserver.observe(wrapper);
  }
}

customElements.define("image-compare", ImageCompare);
